/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type CateringRequestBudgetValidationVariables = Types.Exact<{
  address: Types.Scalars['String']
  attendees: Types.Scalars['Int']
  mealParts: Array<Types.MealPartsInput> | Types.MealPartsInput
  cateringType: Types.Scalars['String']
  dropOff: Types.Scalars['Boolean']
  customerTotalBudgetCents: Types.Scalars['Int']
}>

export type CateringRequestBudgetValidation = {
  __typename: 'Query'
  cateringRequestBudgetValidation: {
    __typename: 'UserError'
    key: string | null
    message: string | null
  } | null
}

export const CateringRequestBudgetValidationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CateringRequestBudgetValidation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'address' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'attendees' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'mealParts' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'MealPartsInput' }
                }
              }
            }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cateringType' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'dropOff' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' }
            }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'customerTotalBudgetCents' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cateringRequestBudgetValidation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'address' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'address' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attendees' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'attendees' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mealParts' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'mealParts' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cateringType' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cateringType' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dropOff' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dropOff' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customerTotalBudgetCents' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'customerTotalBudgetCents' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode

/**
 * __useCateringRequestBudgetValidation__
 *
 * To run a query within a React component, call `useCateringRequestBudgetValidation` and pass it any options that fit your needs.
 * When your component renders, `useCateringRequestBudgetValidation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCateringRequestBudgetValidation({
 *   variables: {
 *      address: // value for 'address'
 *      attendees: // value for 'attendees'
 *      mealParts: // value for 'mealParts'
 *      cateringType: // value for 'cateringType'
 *      dropOff: // value for 'dropOff'
 *      customerTotalBudgetCents: // value for 'customerTotalBudgetCents'
 *   },
 * });
 */
export function useCateringRequestBudgetValidation(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    CateringRequestBudgetValidation,
    CateringRequestBudgetValidationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    CateringRequestBudgetValidation,
    CateringRequestBudgetValidationVariables
  >(CateringRequestBudgetValidationDocument, options)
}
export function useCateringRequestBudgetValidationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CateringRequestBudgetValidation,
    CateringRequestBudgetValidationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CateringRequestBudgetValidation,
    CateringRequestBudgetValidationVariables
  >(CateringRequestBudgetValidationDocument, options)
}
export type CateringRequestBudgetValidationHookResult = ReturnType<
  typeof useCateringRequestBudgetValidation
>
export type CateringRequestBudgetValidationLazyQueryHookResult = ReturnType<
  typeof useCateringRequestBudgetValidationLazyQuery
>
export type CateringRequestBudgetValidationQueryResult = Apollo.QueryResult<
  CateringRequestBudgetValidation,
  CateringRequestBudgetValidationVariables
>
